import type { IssueResponse } from '@data-access/connect/tc-issue-management';
import type { IssueMarkerInfo } from '../types/issue.types';

export function toIssueMarkerInfo(
  issue: IssueResponse | null | undefined
): IssueMarkerInfo | null {
  if (!issue?.marker?.point) return null;

  const { x, y, z } = issue.marker.point;
  if (x === undefined || y === undefined || z === undefined) return null;

  return {
    issueId: issue.id,
    point: { x, y, z },
    type: issue.type,
    priority: issue.priority,
    status: issue.status,
  };
}
